import React from "react";
import { FaPhoneAlt, FaEnvelope, FaCalendarCheck } from "react-icons/fa";
import supply from '../Images/supply.png'

const Supply = () => {
  return (
    <section
      className="container-fluid py-5"
      style={{ backgroundColor: "#FFC94A" }}
    >
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT IMAGE (ONLINE IMAGE) */}
          <div className="col-lg-5 text-center mb-4 mb-lg-0">
            <img
              src={supply}
              alt="Pump Motor and Pipes Supply"
              className="img-fluid"
              style={{ maxHeight: "420px" }}
            />
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-7">
            <div
              className="p-5 text-white"
              style={{
                backgroundColor: "#063970",
                borderRadius: "12px",
              }}
            >
              <h2 className="fw-bold mb-3">
                Reliable Supply of Pump Motors & Pipes
              </h2>

              <p className="mb-4">
                We supply high-quality pump motors and pipes for residential,
                agricultural, commercial, and industrial applications. Our
                products are built for durability, efficiency, and long-term
                performance, ensuring reliable water supply solutions.
              </p>

              {/* CALL BOX */}
              <div
                className="d-flex align-items-center justify-content-center justify-content-lg-start gap-3 mb-4"
                style={{
                  backgroundColor: "#FFC94A",
                  color: "#000",
                  borderRadius: "8px",
                  padding: "14px 20px",
                  maxWidth: "420px",
                }}
              >
                <FaPhoneAlt />
                <strong>+91 94150 39147</strong>
              </div>

              {/* CONTACT OPTIONS */}
              <div className="d-flex flex-column flex-sm-row gap-4">
                <div className="d-flex align-items-center gap-2">
                  <FaEnvelope color="#FFC94A" />
                  <span>dellsonpumpsandpipes@gmail.com</span>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <FaCalendarCheck color="#FFC94A" />
                  <span>Request a Quote</span>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Supply;
